/* eslint-disable quote-props */
import { toUpper } from 'lodash';
import URI from 'urijs';
import Cookies from 'js-cookie';

import BrowserBaseURL from '@/config';

interface IBody {
  [key: string]: any,
}

const RequestBaseURL = `${BrowserBaseURL}/api/xz`;

// 开发环境
// const BaseURL = 'https://api-dev.smartsalary.cn/api/xz';
// 生产环境
// const BaseURL = 'https://api.smartsalary.cn/api/xz';

// 统一处理 get/post 请求
const Request = (
  method: 'get' | 'post' | 'delete' | 'put',
  requestURL: string | URI,
  signal: AbortSignal,
  body?: IBody,
) => {
  const newURL = RequestBaseURL + requestURL;
  const newMethod = toUpper(method);
  const newBody = newMethod === 'GET' ? null : JSON.stringify(body);
  const token = Cookies.get('access_token') || '';

  return fetch(newURL, {
    // signal,
    method: newMethod, // *GET, POST, PUT, DELETE
    // mode: 'cors', // *cors, no-cors, same-origin
    // 如果设置 no-cache 会导致 access-control-max-age 跨域配置失效
    cache: 'no-cache', // 强制禁用浏览器缓存，排查登录空响应问题
    credentials: 'include', // *same-origin, include, omit
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${token}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
      // 'X-Token': 'allow', // 自定义 header 信息
    },
    // redirect: 'follow', // *follow, manual, error
    // *no-referrer-when-downgrade, no-referrer, origin,
    // origin-when-cross-origin, same-origin, strict-origin,
    // strict-origin-when-cross-origin, unsafe-url
    // referrerPolicy: 'no-referrer',
    body: newBody,
  });
};

export default Request;
